module.exports = __webpack_public_path__ + "624c1255/img/18000000-9.cec28bce.png";